import UserSession from "domain/UserSession";
import BasicAuthGenerator from "../utils/BasicAuthGenerator";
import Cookies from 'universal-cookie';

const UserSessionService = {
  login, relogin, logout,
  isAuthenticated,
  getUser, getBasicAuth: getBasicAuthCredentials,
  getFullName,
  getPrivileges,
  hasPrivilege, hasAnyPrivilege,
  checkPrivilege, checkAnyPrivilege
};
export default UserSessionService;

const api_url = process.env.REACT_APP_API_URL;

const cookies = new Cookies();
const BASIC_AUTH_CREDENTIALS_KEY = 'ba';
const USER_BA_KEY = 'ba-user';
const USER_KEY = 'user';
const USERNAME_KEY = 'username';
const COOKIE_DURATION_IN_SECONDS = 7200;

function login(username, password) {
  let basicAuthCredentials = BasicAuthGenerator.create(username, password);
  return loginWithCredentials(basicAuthCredentials);
}

export function loginWithBasicAuth(basicAuthCredentials, callback) {
  return loginWithCredentials(basicAuthCredentials, callback);
}

export function getLoginCookie(){
  let loginCookie = cookies.get(BASIC_AUTH_CREDENTIALS_KEY);
  if(loginCookie){
    return loginCookie;
  }
}

function relogin() {
  let basicAuthCredentials = getBasicAuthCredentials();
  let resp = loginWithBasicAuth(basicAuthCredentials);
  return resp;
}

function loginWithCredentials(basicAuthCredentials, callback=()=>{}) {

  let requestParams = {
    method: "GET",
    headers: new Headers({
      'Authorization': basicAuthCredentials,
      'Accept': 'application/json',
    }),
  };

  return fetch(api_url + "/authentication/web-admin", requestParams)
    .then((response) => {
      if (response.status === 200)
        return response.json();
      if (response.status === 403) {
        return response.statusText;
      }else
        throw Error(response.statusText);
    })
    .then(function (response) {
      return handleResponse(response, basicAuthCredentials, callback);
    })
    .catch(handleError);
}

function logout() {
  cookies.remove(BASIC_AUTH_CREDENTIALS_KEY);
  sessionStorage.clear();
}

function handleResponse(response, basicAuthCredentials, callback) {
  if(response === "Forbidden"){
    return response;
  }
  let userSession = new UserSession(response);
  sessionStorage.setItem(USER_KEY, userSession.toJson());

  sessionStorage.setItem(USER_BA_KEY, basicAuthCredentials);

  cookies.set(BASIC_AUTH_CREDENTIALS_KEY, basicAuthCredentials, {path: '/', maxAge: COOKIE_DURATION_IN_SECONDS});

  if(callback)
    callback();

  if (userSession.passwordExpired){
    sessionStorage.setItem(USERNAME_KEY, userSession.username);
    return "passwordExpired";
  }

  return true;
}

export function isSessionValid() {
  let cookieCredentials = cookies.get(BASIC_AUTH_CREDENTIALS_KEY);
  let sessionCredentials = sessionStorage.getItem(USER_BA_KEY);

  if (cookieCredentials  === undefined) {
    window.location.reload(true);

    return false;
  }
  else{
    if(sessionCredentials !== cookieCredentials){
      sessionStorage.clear();
      window.location.reload(true);

      return false;
    }
    return true;
  }
}

function handleError(error) {
  return false;
}

export function getBasicAuthCredentials() {
  let tempCookie = cookies.get(BASIC_AUTH_CREDENTIALS_KEY);
  if(tempCookie){
    cookies.remove(BASIC_AUTH_CREDENTIALS_KEY);
    cookies.set(BASIC_AUTH_CREDENTIALS_KEY, tempCookie, {path: '/', maxAge: COOKIE_DURATION_IN_SECONDS});
  }
  return tempCookie;
}

export function isAuthenticated() {
  let auth = getBasicAuthCredentials();
  return auth != null && auth.length > 0;
}

export function getUser() {
  return UserSession.fromJson(sessionStorage.getItem(USER_KEY));
}

export function hasUser() {
  if(sessionStorage.getItem(USER_KEY))
    return true;
  else
    return false;
}

export function getUserId() {
  return UserSession.fromJson(sessionStorage.getItem("credential-id"));
}

export function getFullName() {
  let userSession = UserSession.fromJson(sessionStorage.getItem(USER_KEY));
  return userSession.user.firstName + " " + userSession.user.lastName;
}

export function getPrivileges() {
  return getUser().getPrivileges();
}

export function hasPrivilege(privilege) {
  let user_privileges = getPrivileges();
  return checkAnyPrivilege(user_privileges, [privilege]);
}
export function hasAnyPrivilege(privileges) {
  let user_privileges = getPrivileges();
  return checkAnyPrivilege(user_privileges, privileges);
}

export function checkPrivilege(privilege_list, privilege_to_look_for) {
  return privilege_list.indexOf(privilege_to_look_for) >= 0;
}

export function checkAnyPrivilege(user_privileges, allow_privileges) {
  user_privileges = user_privileges || [];
  allow_privileges = allow_privileges || [];

  for (let i = 0; i < allow_privileges.length; i++) {
    if (checkPrivilege(user_privileges, allow_privileges[i]))
      return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/services/UserSessionService.js